import React from "react";

const Footer = () => {
  return (
    <div style={{ textAlign: "center", fontSize: "2rem" }}>
      Made with 💖 by{" "}
      <a
        href="https://github.com/whyMalem/cred-clone"
        target="_blank"
        rel="noreferrer"
        style={{ cursor: "pointer" }}
      >
        Malem Yengkhom
      </a>{" "}
    </div>
  );
};

export default Footer;
